import { Link } from "react-router-dom";

export type BreadcrumbObject = {
    path: string;
    text: string;
};
export type BreadcrumbProps = {
    breadcrumb: BreadcrumbObject[];
    currentPath: string;
    className?: string;
    style?: React.CSSProperties;
};
const Breadcrumb = ({ breadcrumb, currentPath }: BreadcrumbProps) => {
    // destructure the array from react router
    // add the categories list to redux
    // assign categories and products names to links
    return (
        <div className="w-full flex flex-row-reverse gap-2 justify-start items-center py-2 px-4">
            {breadcrumb.map((route) => (
                <div
                    className="flex gap-1 justify-center items-center"
                    key={route.path}
                    style={{ padding: 0 }}
                >
                    <p className="text-momeento-50 font-medium">/</p>
                    <Link
                        to={route.path}
                        className="text-momeento-50 font-medium"
                    >
                        {route.text}
                    </Link>
                </div>
            ))}
            <span className="text-momeento-50">{currentPath}</span>
        </div>
    );
};

export default Breadcrumb;
